import { Login } from 'features/login';
import type { FC } from 'react';
import { Titled } from 'react-titled';

const LoginPage: FC = () => {
  return (
    <>
      <Titled title={(title) => `WellTech User Acquisition | ${title}`} />
      <Login />
    </>
  );
};

export default LoginPage;
